export const LogLevel = {
  DEBUG: 1,
  INFORMATION: 2,
  WARNING: 3,
  ERROR: 4,
  CRITICAL: 5,
};
